import { SplitterDesignTokens } from "@primeuix/themes/types/splitter"

export default {
  'gutter.background': '{surface.50}',
  handle: {
    size: '24px',
    background: '{surface.200}',
    borderRadius: '{content.border.radius}'
  }
} as SplitterDesignTokens
